import { Offer } from 'app/services/offers/offer.model';

export enum OfferSnackBarType {
  PUBLISH,
  REMOVE_FROM_PORTAL
}

export interface IOfferSnackBarData {
  offer: Offer;
  isSuccess: boolean;
  type: OfferSnackBarType;
}
